<template>
  <!-- 没内容提示 -->
  <div class="wrap-no-content">
    <div class="no-content">
      <img :src="require('./' + imgUrl)" alt="">
      <div>{{ msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  props: {
    msg: {
      type: String,
      required: false,
      default: '暂时没有内容显示'
    },
    imgUrl: {
      type: String,
      required: false,
      default: 'no-content.png'
    }
  },
  data () {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.wrap-no-content{
  width: 100%;
  height: 100%;
  position: relative;
  .no-content{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    &>div{
      color: $color-white;
      font-size: 26px;
    }
    img{
      width: 254px;
      height: 213px;
    }
  }
}
</style>
